import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

const useFetchIfNeeded = (selector, fetchAction, fetchArgs = null) => {
  const storeData = useSelector((state) => state);
  const data = useSelector(selector);
  const dispatch = useDispatch();

  useEffect(() => {
    const key = fetchArgs?.storeKey ? fetchArgs?.storeKey : fetchArgs?.key;
    if (!key) return;
    // Check if totalCount is stored in the Redux state for this key.
    // If it exists and equals 0, then there's no data so we should not fetch.
    if (
      key &&
      storeData.data[key] &&
      storeData.data[key].totalCount !== undefined &&
      storeData.data[key].totalCount === 0
    ) {
      return;
    }

    // If data is not available or an empty array, dispatch the fetch if not loading or errored.
    if (
      ((!storeData.data[key] || Object.keys(storeData.data[key]).length < 2) &&
        !storeData.loading[key]) ||
      (Array.isArray(data) && data.length === 0)
    ) {
      if (fetchArgs?.key === 'tagsByModule') {
        if (!storeData.loading[key] && !storeData.error[key]) {
          dispatch(fetchAction(fetchArgs));
        }
      }
      if (fetchArgs?.inputData?.filterJson === null) {
        if (!storeData.loading[key] && !storeData.error[key]) {
          dispatch(fetchAction(fetchArgs));
        }
      } else if (fetchArgs?.inputData === undefined) {
        if (!storeData.loading[key] && !storeData.error[key]) {
          dispatch(fetchAction(fetchArgs));
        }
      }
    }
  }, [data, dispatch, fetchAction, fetchArgs, storeData]);

  return data;
};

export default useFetchIfNeeded;
